import { render } from "./CheckboxList.vue?vue&type=template&id=485ecb50&scoped=true"
import script from "./CheckboxList.vue?vue&type=script&lang=js"
export * from "./CheckboxList.vue?vue&type=script&lang=js"

import "./CheckboxList.vue?vue&type=style&index=0&id=485ecb50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485ecb50"]])

export default __exports__